export default "__VITE_ASSET__6XMBxRw1__"